const auth = require('./auth');
const codes = require('./codes');
const comics = require('./comics');
const configuration = require('./configuration');
const landingPages = require('./landingPages');
const loots = require('./loots');
const network = require('./network');
const purchases = require('./purchases');
const statistics = require('./statistics');
const bannerSlots = require('./bannerSlots');
const debug = require('./debug');
const rewardChannels = require('./rewardChannels');
const recruitment = require('./recruitment');
const ranking = require('./ranking');
const settings = require('./settings');
const offers = require('./offers');
const userQuotes = require('./userQuotes');
const subscriptionPlans = require('./subscriptionPlans');
const subscription = require('./subscription');
const ticketOffers = require('./ticketOffers');
const tradingCampaigns = require('./tradingCampaigns');
const tradingCampaignBalances = require('./tradingCampaignBalances');
const newsFeed = require('./newsFeed');
const daily = require('./dailyQuests');
const dailyProgress = require('./questsProgress');
const legal = require('./legal');
const tags = require('./tags');
const ephemeralMiscellanea = require('./ephemeralMiscellanea');
const readComics = require('./readComics');
const filters = require('./filters');
const searchInput = require('./searchInput');
const dailyBoostInterval = require('./dailyBoost');
const intervalProgress = require('./intervalProgress');

module.exports = {
  auth,
  codes,
  comics,
  configuration,
  landingPages,
  loots,
  network,
  purchases,
  statistics,
  bannerSlots,
  debug,
  rewardChannels,
  recruitment,
  ranking,
  settings,
  offers,
  userQuotes,
  subscriptionPlans,
  subscription,
  ticketOffers,
  tradingCampaigns,
  tradingCampaignBalances,
  newsFeed,
  daily,
  dailyProgress,
  legal,
  tags,
  ephemeralMiscellanea,
  readComics,
  filters,
  searchInput,
  dailyBoostInterval,
  intervalProgress,
};
